module.exports = __webpack_public_path__ + "img/success-icon.7a2c0d4a.png";